import React, { useEffect } from 'react';
import HomeStyle from './style';
import Modal from "../../Container/Modal";
import {DragDropContext, Droppable, Draggable} from 'react-beautiful-dnd';


import Sort from "../../Assets/sort.svg";
import DeleteIcon from "../../Assets/Delete.svg";
import Pen from "../../Assets/pen.svg";
import { useState } from 'react';
import RightSideBar from "../../Container/RightSidebar/videos";

// -- redux
import {connect} from "react-redux";
import {GetVideos, UpdateVideosStatus, DeleteVideos, UpdateVideoOrderStatus} from "../../Redux/Actions/VideosAction"
import Loader from "../../Container/Loader";
import Handle from "../../Assets/handle.svg";


function Videos(props) {
    const [Open, SetOpen] = useState(false);
    const [Data, SetData] = useState('');
    const [InitialArray, setInitialArray] = useState([]);
    const [CardsArray, setCardsArray] = useState([]);
    const [Name, setName] = useState(false);
    const [OpenModal, setModal] = useState(false);
    const [Id, setId] = useState(false);

    const handleOnDragEnd = (result) => {
        if (!result.destination) return;
        const items = Array.from(CardsArray);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        setCardsArray(items);
        passData(items)
    };

    const passData = (items) => {
        let data = [];
        items.map((arr) =>{
            let index = items.findIndex(x => x.title === arr.title);
            let id = items.filter(x => x.id === arr.id);
            data.push(
                {
                    id: id[0].id,
                    order_number: index + 1
                }
            )
        });
        props.UpdateVideoOrderStatus(data);
    };

    const handleEdit = (e, data) => {
        e.preventDefault();
        SetData(data);
        SetOpen(true)
    };

    useEffect(() => {
        const data = {
            status: props.status
        };
        props.GetVideos(data);
    }, [props.update_data, props.status, props.delete_data, props.add_data, props.edit_data, props.order_data]);

    useEffect(() => {
        props.clear('clear');
    }, []);

    useEffect(()=> {
        if(props.data &&  props.data.data) {
            props.enabled(props.data.data.enabled);
            props.disabled(props.data.data.disabled);
            setInitialArray(props.data.data.data);
        }
    },[props.data, props.update_data, props.delete_data, props.add_data, props.edit_data]);

    useEffect(() => {
        if(props.data && props.data.data && props.data.data.data){
            setCardsArray(InitialArray);
        }
        setTimeout( function() {props.clear('')}, 1000)
    }, [props.update_data, props.add_data, props.edit_data, InitialArray]);

    const deleteVideos = (e, type, id) => {
        e.preventDefault();
        setModal(type);
        setId(id)
    };

    const handleModal = (e, type, name, id) => {
        e.preventDefault();
        setModal(type);
        setName('this video');
        setId(id)
    };

    const CloseModal = (e, type) => {
        e.preventDefault();
        let data;
        if(type === 'enable_yes'){
            data = {
                id: Id,
                status: 0
            };
            props.UpdateVideosStatus(data);
        } else{
            setModal(!OpenModal)
        }

        if(type === 'disable_yes'){
            data = {
                id: Id,
                status: 1
            };
            props.UpdateVideosStatus(data);
        } else{
            setModal(!OpenModal)
        }

        if(type === 'delete_yes'){
            props.DeleteVideos(Id);
            setModal(false)
        } else if(type === 'delete_no'){
            setModal(false)
        }
    };

    useEffect(() => {
        if(!props.Search){
            setCardsArray(InitialArray);
        }
        if(props.Search.length > 2){
            const FilteredArray = InitialArray.filter((post) => {
                const postName = post.title;
                return postName.toLowerCase().includes(props.Search.toLowerCase());
            });
            setCardsArray(FilteredArray)
        }
    }, [props.Search]);

    const useSortableData = (items, config = null) => {
        const [sortConfig, setSortConfig] = React.useState(config);

        const sortedItems = React.useMemo(() => {
            let sortableItems = [...items];
            if (sortConfig !== null) {
                sortableItems.sort((a, b) => {
                    if (a[sortConfig.key] < b[sortConfig.key]) {
                        return sortConfig.direction === 'ascending' ? -1 : 1;
                    }
                    if (a[sortConfig.key] > b[sortConfig.key]) {
                        return sortConfig.direction === 'ascending' ? 1 : -1;
                    }
                    return 0;
                });
            }
            return sortableItems;
        }, [items, sortConfig]);

        const requestSort = (key) => {
            let direction = 'ascending';
            if (
                sortConfig &&
                sortConfig.key === key &&
                sortConfig.direction === 'ascending'
            ) {
                direction = 'descending';
            }
            setSortConfig({ key, direction });
        };

        return { items: sortedItems, requestSort, sortConfig };
    };
    const { items, requestSort, sortConfig } = useSortableData(CardsArray);

    return (
        <>
            {props.loading && <Loader/>}
            <div className="ml-4 mr-2">
                <div className="module-table-wrap table-responsive">
                    <div className="table-wrap">
                        <table className="table table-bordered">
                            <thead className='text-grey-6'>
                                <tr>
                                    <th className='dark-background cursor-pointer' style={{width: '100px'}}/>
                                    <th scope="col" className='dark-background cursor-pointer'>
                                        <div className="d-flex justify-content-between" onClick={() => requestSort('title')}>
                                            <span className='f-16'>Title</span>
                                            <img src={Sort} alt="sort" className="ml-2"/>
                                        </div>
                                    </th>
                                    <th scope="col" className='dark-background cursor-pointer' style={{width:'50%'}}>
                                        <div className="d-flex justify-content-between" onClick={() => requestSort('video_url')}>
                                            <span className='f-16'>URL</span>
                                            <img src={Sort} alt="sort" className="ml-2"/>
                                        </div>
                                    </th>
                                    <th scope="col" className='dark-background'>
                                        <div className="d-flex justify-content-between">
                                            <span className='f-16'>Status</span>
                                        </div>
                                    </th>
                                    <th scope="col" className='dark-background'>
                                        <div className="d-flex justify-content-between">
                                            <span className='f-16'>Action</span>
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            {items.length > 0 ?
                                <DragDropContext onDragEnd={handleOnDragEnd}>
                                    <Droppable droppableId="home_listing" type="listing">
                                        {(provided) => (
                                            <tbody {...provided.droppableProps} ref={provided.innerRef}>
                                                {items.map((item,index)=>{
                                                        return <Draggable key={item.id} draggableId={(item.id).toString()} index={index}>
                                                            {(provided) => (
                                                                <tr
                                                                    ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}
                                                                    key={index}>
                                                                    <td className='light-grey-background text-white text-center'>
                                                                        <img src={Handle} alt='Handle'/>
                                                                    </td>
                                                                    <td className='light-grey-background text-white' style={{whiteSpace: 'unset'}}>
                                                                        <span className='f-16'>
                                                                            {item.title}
                                                                        </span>
                                                                    </td>
                                                                    <td className='light-grey-background text-white' style={{whiteSpace: 'unset', width: '50%'}}>
                                                                        <span className='f-16 pr-3' style={{width: '150px', wordBreak: 'break-all'}}>
                                                                            {item.video_url}
                                                                        </span>
                                                                    </td>
                                                                    <td className='text-center light-grey-background text-white'>
                                                                        <label className="switch mb-0">
                                                                            <input
                                                                                 type="checkbox"
                                                                                 checked={item.status === 1}
                                                                                 readOnly
                                                                                    onClick={(e) => handleModal(e, item.status === 1 ? 'enable' : 'disable', item.title, item.id)}
                                                                            />
                                                                            <span className="slider round"/>
                                                                        </label>
                                                                    </td>
                                                                    <td className='light-grey-background text-white'>
                                                                        <div className="d-flex">
                                                                            <img src={Pen} alt="pen" className="mr-2 ml-2 cursor-pointer" onClick={(e)=> handleEdit(e, item)}/>
                                                                            <img onClick={(e) => deleteVideos(e, 'delete', item.id)} src={DeleteIcon} alt="Delete" className="ml-2 mr-3 cursor-pointer"/>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </Draggable>
                                                     })}
                                            </tbody>
                                        )}
                                    </Droppable>
                                </DragDropContext>
                                    :
                                <tbody className='light-grey-background text-white'>
                                    <tr>
                                        <td colSpan='4' className='text-center border-0'>
                                            <div className='d-flex text-center justify-content-center'>
                                                <p className='m-0 text-white'>Nothing found</p>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            }
                        </table>
                    </div>
                </div>
                <HomeStyle/>
                <RightSideBar
                    Type='Edit'
                    data={Data}
                    sidebar={Open}
                    close={() =>  SetOpen(false)}
                    response={(e) => (e)}
                />
                { OpenModal && <Modal Name={Name} Type={OpenModal} Close={(e, type) => CloseModal(e, type)}/> }
            </div>
        </>
    );
}

const mapStateToProps = ({VideosReducer}) => {
    const { loading, table_loading, data, update_data, delete_data, add_data, edit_data, order_data} = VideosReducer;
    return { loading, table_loading, data, update_data, delete_data, add_data, edit_data, order_data}
};

const mapDispatchToProps = {
    GetVideos,
    UpdateVideosStatus,
    DeleteVideos,
    UpdateVideoOrderStatus
};

export default connect(mapStateToProps, mapDispatchToProps)(Videos);